import React, { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { forgotPassword } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const d = await forgotPassword(email); setMessage(d.message); setSent(true); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-16" data-testid="forgot-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <KeyRound className="h-10 w-10 mx-auto text-atlas-blue mb-3" />
          <h1 className="font-display text-3xl font-bold tracking-tight">Reset your password</h1>
          <p className="text-muted-foreground mt-1">We'll email you a secure reset link.</p>
        </div>
        {sent ? (
          <div className="bg-card border border-border rounded-md p-8 text-center" data-testid="forgot-sent">
            <p className="text-sm text-slate-700">{message}</p>
            <Button asChild variant="outline" className="mt-6"><Link to="/login">Back to sign in</Link></Button>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-card border border-border rounded-md p-6 md:p-8 space-y-5">
            <div className="space-y-1.5">
              <Label className="overline">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com" required data-testid="forgot-email" />
            </div>
            <Button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full bg-primary hover:bg-atlas-blue text-white py-6">
              {busy ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Sending…</> : "Send reset link"}
            </Button>
            <p className="text-sm text-muted-foreground text-center">
              <Link to="/login" className="text-atlas-blue font-medium">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
